<template>
  <div class="absolute top-0 left-0 z-50 w-screen h-screen pt-safe pb-safe">
    <info-screen
      :title="t('update-modal.title')"
      :message="t('update-modal.subtitle-mandatory')"
      :image="UpdateImage"
      :confirm-text="t('update-modal.update-cta')"
      @confirm="$emit('confirm')"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import UpdateImage from '@/assets/update.svg'
import InfoScreen from '@/components/InfoScreen.vue'

const { t } = useI18n()

defineEmits<{
  confirm: []
}>()
</script>
